module.exports = __webpack_public_path__ + "static/media/white-spinner.f8d51a24.gif";